<template>
  <div class="block-teaser-blog-dossier">
    <div class="block-teaser-blog-dossier__pretitle">
      {{ data.pretitle }}
    </div>
    <div class="block-teaser-blog-dossier__title">
      {{ data.title }}
    </div>
    <div class="block-teaser-blog-dossier__teaser-wrapper">
      <div class="block-teaser-blog-dossier__big-teaser">
        <BlockTeaserBlogCard
          :key="rerenderBlock"
          :data="firstArticle"
          :is-first-article="true"
        />
      </div>

      <masonry-wall
        class="block-teaser-blog-dossier__masonry"
        :items="blogs"
        :min-columns="isMobile ? 1 : 3"
        :column-width="300"
        :gap="isMobile ? 20 : 34"
      >
        <template #default="{ item, index }">
          <BlockTeaserBlogCard
            :key="item._uid"
            :data="item"
            :index="index"
          />
        </template>
      </masonry-wall>
    </div>
  </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const clientDeviceStore = useClientDeviceStore();
const isMobile = computed(() => clientDeviceStore.isMobile);
const storyStore = useStoryStore();
const blogs = ref([]);
const firstArticle = ref([]);

const currentStory = storyStore.getCurrentStory;
const uuidDossier = currentStory.story.uuid;

const storyblokApi = useStoryblokApi();

/* Used to force rerender of the firstarticlecomponent */
const rerenderBlock = ref(0);
const forceRerender = () => {
    rerenderBlock.value += 1;
};

/*
  Get the data from the API
  If there is a filter, we need to get the data from the filter
  If there is no filter, we need to get the data from the first 7 blogs
*/
const getData = async () => {
    try {
        const { data } = await storyblokApi.get('cdn/stories/', {
            starts_with: 'blogs/',
            version: 'published',
            is_startpage: false,
            per_page: 7,
            sort_by: 'first_published_at:desc',
            filter_query: {
                dossiers: {
                    in_array: uuidDossier,
                },
            },
        });

        blogs.value = data.stories;
        firstArticle.value = blogs.value.shift();
        forceRerender();
    } catch (e) {
        useSentryError(e);
    }
};

getData();
</script>

<style lang="scss" scoped>
.block-teaser-blog-dossier {
    @include grid-columns();
    @include fluid('margin-bottom', 60px, 120px);

    display: flex;
    flex-direction: column;
    color: $C_GREEN_DARK;
}

.block-teaser-blog-dossier__pretitle {
    @include typo-font('light');
    @include typo-size('pretitleblog');
}

.block-teaser-blog-dossier__title {
    @include typo-font('regular');
    @include typo-size('lead');

    margin-bottom: 16px;

    @include mobile {
        margin-bottom: 20px;
    }
}

.block-teaser-blog-dossier__teaser-wrapper {
    @include grid-layout();

}

.block-teaser-blog-dossier__big-teaser {
    grid-column: span 6;
}

.block-teaser-blog-dossier__masonry {
    grid-column: span 12;

    @include mobile {
        grid-column: span 6;
    }
}
</style>
